export default "__VITE_ASSET__Cvzw_XWJ__"